import { api } from '../../../lib/api'

export const GET_USER_NOTIFICATIONS_REQUEST = 'GET_USER_NOTIFICATIONS_REQUEST'
export const GET_USER_NOTIFICATIONS_SUCCESS = 'GET_USER_NOTIFICATIONS_SUCCESS'
export const GET_USER_NOTIFICATIONS_FAILED = 'GET_USER_NOTIFICATIONS_FAILED'

export const getUserNotifications = function () {
  return function (dispatch) {
    dispatch({
      type: GET_USER_NOTIFICATIONS_REQUEST
    })
    api.getUserNotifications().then(getNotificationsResponse => {
      dispatch({
        type: GET_USER_NOTIFICATIONS_SUCCESS,
        payload: getNotificationsResponse
      })
    }).catch(error => {
      dispatch({
        type: GET_USER_NOTIFICATIONS_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/notification/get-user-notifications.js